import React, { useState, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from '../context/LanguageContext';
import apiRequest from '../services/api';

const SetupGuard = ({ children }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [status, setStatus] = useState('loading'); // 'loading', 'completed', 'pending'

  useEffect(() => {
    const checkSetup = async () => {
      try {
        // 使用apiRequest，它会自动处理401重定向到登录页
        const data = await apiRequest('/api/setup/status');
        if (data.status === 'success' && data.setup_completed) {
          setStatus('completed');
        } else {
          setStatus('pending');
        }
      } catch (err) {
        // API 异常（token 过期、网络错误、服务器维护等）
        // 不重定向到 /setup——系统可能已初始化，只是临时不可用
        // 直接视为 completed，用户留在当前页
        console.warn('Setup check error (assuming completed):', err);
        setStatus('completed');
      }
    };
    checkSetup();
  }, []);

  if (status === 'loading') {
    return <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 text-slate-400">{t('common.loading_system_status')}</div>;
  }

  // 如果系统未初始化，重定向到setup页面
  if (status === 'pending') {
    // 如果已经在setup页面，不重定向
    if (location.pathname === '/setup') {
      return children ? children : <Outlet />;
    }
    return <Navigate to="/setup" replace />;
  }

  // 系统已初始化
  // 如果当前在setup页面，重定向到首页
  if (location.pathname === '/setup') {
    return <Navigate to="/" replace />;
  }

  return children ? children : <Outlet />;
};

export default SetupGuard;
